import { BookmarkIcon, ImportIcon } from '@maersktankersdigital/web-components'
import { format } from 'date-fns'
import TagManager from 'react-gtm-module'
import { useAddBookmark } from '~hooks/queries/documents/use-add-bookmark'
import { useGetDocumentUrl } from '~hooks/queries/documents/use-get-document-url'
import { IDocument } from '~hooks/queries/documents/use-get-documents'
import { useRemoveBookmark } from '~hooks/queries/documents/use-remove-bookmark'
import {
  BookmarkWrapper,
  ContentWrapper,
  DocumentButtons,
  DocumentInfo,
  DocumentSeparator,
  DocumentWrapper,
  FileIconWrapper,
  StyledBookmarkFilledIcon,
} from '~pages/pages-behind-login/documents/documents.styles'
import { getFileIcon } from '~pages/pages-behind-login/documents/file-type/file-type-icon-helper'
import { trackDownloadButtonClick } from '../calendar/tracking/tracking-calendar'

export function Document({
  bookmarkData,
  singleDocument,
}: {
  bookmarkData: number[]
  singleDocument: IDocument
}) {
  const { mutate: removeBookmark } = useRemoveBookmark()
  const { mutate: addBookmark } = useAddBookmark()

  const { refetch: fetchDocumentUrl } = useGetDocumentUrl({
    documentId: singleDocument?.id,
  })

  const onClickHandler = async () => {
    const { data: url } = await fetchDocumentUrl()
    if (url) {
      downloadFile({ url: url.url, title: singleDocument.title })
    }
  }

  return (
    <DocumentWrapper key={singleDocument.id}>
      <ContentWrapper>
        <FileIconWrapper>
          {getFileIcon(singleDocument.fileType)}
        </FileIconWrapper>
        <DocumentInfo
          publishDate={format(
            new Date(singleDocument.publishDate),
            'dd MMM yyyy',
          )}
          title={singleDocument.title}
          category={singleDocument.category}
        />
      </ContentWrapper>
      <DocumentSeparator />
      <DocumentButtons>
        <ImportIcon onClick={() => onClickHandler()} />
        {bookmarkData && (
          <BookmarkWrapper
            onClick={() => {
              if (bookmarkData?.includes(singleDocument.id)) {
                trackBookmarkButtonClick(singleDocument.title, 'removeBookmark')
                removeBookmark(singleDocument.id)
              } else {
                trackBookmarkButtonClick(singleDocument.title, 'addBookmark')
                addBookmark({ documentId: singleDocument.id })
              }
            }}
          >
            {bookmarkData?.includes(singleDocument.id) ? (
              <StyledBookmarkFilledIcon />
            ) : (
              <BookmarkIcon />
            )}
          </BookmarkWrapper>
        )}
      </DocumentButtons>
    </DocumentWrapper>
  )
}

export function downloadFile({ url, title }: { url: string; title: string }) {
  trackDownloadButtonClick(title)

  const a = document.createElement('a')
  a.href = url
  a.target = '_blank'
  a.download = title
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

function trackBookmarkButtonClick(
  title: string,
  type: 'removeBookmark' | 'addBookmark',
) {
  const tagManagerArgs = {
    dataLayer: {
      event: 'internal_click',
      click_type:
        type === 'removeBookmark'
          ? 'Remove Bookmark from Document'
          : 'Bookmark Document',
      click_subtype: title,
    },
  }
  TagManager.dataLayer(tagManagerArgs)
}
